import { useContext } from 'react';
import { SortableItemContext } from '../context';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { IconButton, SxProps } from '@mui/material';

export interface DragHandleProps {
  sx?: SxProps;
}

export const DragHandle: React.FC<DragHandleProps> = ({ sx }) => {
  const { attributes, listeners, ref } = useContext(SortableItemContext);

  return (
    <IconButton
      sx={{ border: 'none', backgroundColor: 'transparent', ...sx }}
      {...attributes}
      {...listeners}
      ref={ref}
    >
      <DragIndicatorIcon />
    </IconButton>
  );
};
